// import React, { useState } from 'react';
// import logo from './logo.png';
import './App.css';
// import Schedule from './schedule';
import { useNavigate } from 'react-router-dom';
// import redbird1 from './images/redbird1.jpeg';




function ContactBar() {
  const navigate = useNavigate();

  function globalNavigation(destination: string) {
    // const navigate = useNavigate();
    navigate(destination);
  }

  function openExternalLink(url: string) {
    window.open(url, '_blank');
  }



  const goToSchedulePage = () => {
    navigate('/schedule');
  };

  return (
    <div className="contactBar">
      <div  className="genericFlexColumn"  style={{  height:"100%",gap:10}}>
        <h1>Social Media</h1>
        {/* <button onClick={() => globalNavigation("")}>Facebook</button> */}
        <button onClick={() => openExternalLink("https://www.instagram.com/vfrnotrecommended/")}>Instagram</button>
      </div>

      <div className="genericFlexColumn"  style={{  height:"100%",gap:10}}>
        <h1>Contact</h1>
        <p style={{ color: "white", fontWeight: "bolder" }}>info@vfrnr.com</p>
      </div>

      <div className="genericFlexColumn" style={{  height:"100%",gap:10}}>
        {/* <h1>Quick Links</h1> */}
                {/* <button onClick={() => globalNavigation("schedule")}>Send Email</button> */}

        {/* <button onClick={() => openExternalLink("https://calendly.com/vfrnr")}>Book Time Now!</button> */}
      </div>
    </div>
  );
}

export default ContactBar;